<template>
    <svg
        viewBox="0 0 24 24"
        :width="width"
        :height="height"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="{ spinning: loading }"
    >
        <path
            d="M16.4922 7.30469C15.2422 6.21094 13.7448 5.65104 12 5.625C10.0469 5.67708 8.43229 6.35417 7.15625 7.65625C5.85417 8.93229 5.17708 10.5469 5.125 12.5C5.17708 14.4531 5.85417 16.0677 7.15625 17.3438C8.43229 18.6458 10.0469 19.3229 12 19.375C13.5885 19.349 14.9688 18.8932 16.1406 18.0078C16.6094 17.6953 17.0391 17.7604 17.4297 18.2031C17.7422 18.6719 17.6771 19.1016 17.2344 19.4922C15.75 20.638 14.0052 21.224 12 21.25C10.3594 21.224 8.88802 20.8203 7.58594 20.0391C6.25781 19.2839 5.21615 18.2422 4.46094 16.9141C3.67969 15.612 3.27604 14.1406 3.25 12.5C3.27604 10.8594 3.67969 9.38802 4.46094 8.08594C5.21615 6.75781 6.25781 5.71615 7.58594 4.96094C8.88802 4.17969 10.3594 3.77604 12 3.75C14.2917 3.80208 16.2318 4.54427 17.8203 5.97656L19.0312 4.76562C19.2917 4.50521 19.6172 4.375 20.0078 4.375C20.3984 4.375 20.724 4.50521 20.9844 4.76562C21.2448 5.02604 21.375 5.35156 21.375 5.74219V10.3125C21.3229 10.8854 21.0104 11.1979 20.4375 11.25H15.8672C15.4766 11.25 15.151 11.1198 14.8906 10.8594C14.6302 10.599 14.5 10.2734 14.5 9.88281C14.5 9.49219 14.6302 9.16667 14.8906 8.90625L16.4922 7.30469Z"
            :fill="color"
        />
    </svg>
</template>
<script>
export default {
    name: 'icon-reload',
    props: {
        width: {
            type: Number,
            required: true
        },

        height: {
            type: Number,
            required: true
        },

        color: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false,
        },
    }
}
</script>
<style scoped>
.spinning {
    animation: spin 1.2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    transform-origin: 50% 50%;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>